import { render } from "./accountButton.vue?vue&type=template&id=3051093c&scoped=true&ts=true"
import script from "./accountButton.vue?vue&type=script&lang=ts"
export * from "./accountButton.vue?vue&type=script&lang=ts"

import "./accountButton.vue?vue&type=style&index=0&id=3051093c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3051093c"]])

export default __exports__